import React from 'react';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';

export const TaskFilterComponent = (props) => {
    return (
        <form className="form-fullwidth" >
            <Grid container spacing={2}>
            <Grid item xs={12}>
                <FormControl variant="standard">
                    <InputLabel htmlFor="status">Status</InputLabel>
                    <Select
                        value={props.FilterStatus} onChange={props.HandleOnChange}
                        inputProps={{
                            name: 'filter_status',
                            id: 'filter_status',
                        }}>
                        <MenuItem value="all">All</MenuItem>
                        <MenuItem value={1}>Active</MenuItem>
                        <MenuItem value={0}>Inactive</MenuItem>
                    </Select>
                </FormControl>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={6} style={{ textAlign: "right" }}>
            <Button variant="contained" color="primary" className={'filterSubmitButton'} onClick={props.handleOnSubmit}> Submit </Button>
            </Grid>
        </form>
    )
}
